import { gql } from '@common/hooks';
import { CSVError } from 'works/legacy/lib/csv-error';

export const ValidateWorksMembershipImport = gql`
  mutation ValidateWorksMembershipImport(
    $input: ValidateWorksMembershipImportInput!
  ) {
    validateWorksMembershipImport(input: $input) {
      success
      members {
        email
        employeeId
        firstName
        lastName
        phoneNumber
        role
        isUpdate
      }
      errors {
        row
        type
        field
        message
      }
    }
  }
`;

export type ImportMember = {
  firstName: string;
  lastName: string;
  email: string;
  employeeId: string;
  phoneNumber: string;
  role: string;
  isUpdate: boolean;
};

export type ValidateWorksMembershipImportResponse = {
  validateWorksMembershipImport: {
    members: ImportMember[];
    errors: CSVError[];
    success: boolean;
  };
};

export type ValidateWorksMembershipImportVariables = {
  input: {
    file: File;
  };
};
